import { OfferFilterSettingsModel } from './offerFilterSettingsModel';
export class OfferFilterDataModel {
    public filterSettings: OfferFilterSettingsModel;
    public from: number;
    public numberOfRows: number;
    public currentPage: number;
}